module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navbar', {
    staticClass: "white"
  }, [_c('v-navbar-side-icon', {
    directives: [{
      name: "sidebar",
      rawName: "v-sidebar:mainsidebar",
      arg: "mainsidebar"
    }],
    staticClass: "hidden-sm-and-up"
  }), _vm._v(" "), _c('v-navbar-logo', [_c('h1', {
    staticClass: "navbar__title"
  }, [_vm._v("VTHACKS")])]), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-down"
  }), _vm._v(" "), _c('v-navbar-items', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "items": _vm.itemsGroup
    }
  }), _vm._v(" "), _c('v-navbar-items', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "items": _vm.authenticated
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1aea6a84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 81
// module chunks = 1